const APP_TYPES = {
  BOOKMARK: 'bookmark',
  PAID_APP: 'paidApp',
  FREE_APP: 'freeApp',
  INVALID: 'invalid',
};

export default APP_TYPES;
